export const surveyStates = {
  initializing: 'initializing',
  surveyLanding: 'surveyLanding',
  answeringQuestions: 'answeringQuestions',
  waitingForUploads: 'waitingForUploads',
  completed: 'completed',
  failed: 'failed',
  terminated: 'terminated',
}

export default surveyStates
